import { useStorageBackedState } from 'use-storage-backed-state'

export function useIsVatPreferred() {
	return useStorageBackedState(true, 'is-vat-preferred')
}
